import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';

import { recenter } from './RecenterButton.css';

function RecenterButton({ onClick, show }) {
  return show && (
    <Button
      className={recenter}
      data-test-id="recenter-btn"
      mode="map"
      onClick={onClick}
    >
      {getMessage('recenter')}
    </Button>
  )
}

RecenterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default RecenterButton;
